import * as React from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { SketchPicker } from "react-color";

export interface ColorDialogProps {
  id: string;
  keepMounted: boolean;
  color: any;
  open: boolean;
  onClose: (value?: any) => void;
}

export default function ColorDialog(props: ColorDialogProps) {
  const { onClose, color: valueProp, open, ...other } = props;
  const [color, setcolor] = React.useState(valueProp);
  const handleColorChange = (color) => setcolor(color);

  React.useEffect(() => {
    if (!open) {
      setcolor(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(color);
  };

  return (
    <Dialog sx={{ "& .MuiDialog-paper": { width: "85%", maxHeight: 435 } }} maxWidth="xs" open={open} {...other}>
      <DialogContent>
        <SketchPicker color={color} onChange={handleColorChange} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
